import {
    KNOWLEDGE_DATA_LIST_REQUEST,
    KNOWLEDGE_DATA_LIST_RESPONSE,
    KNOWLEDGE_DATA_LIST_CACHED_RESPONSE,
    KNOWLEDGE_DATA_LIST_ERROR_RESPONSE
} from "./action-types"
import {
    listRequest,
    listResponse,
    listErrorResponse,
    listCachedResponse
} from "./default-actions/paging-actions"

// Paging actions
const defaultKnowledgeDataListRequest = listRequest(KNOWLEDGE_DATA_LIST_REQUEST)
export const knowledgeDataListRequest = (pagingRequest: Object) => ({
    ...defaultKnowledgeDataListRequest(pagingRequest),
    limit: 500,
    offset: 0
})
export const knowledgeDataListResponse = listResponse(KNOWLEDGE_DATA_LIST_RESPONSE)
export const knowledgeDataListCachedResponse = listCachedResponse(
    KNOWLEDGE_DATA_LIST_CACHED_RESPONSE
)
export const knowledgeDataListErrorResponse = listErrorResponse(
    KNOWLEDGE_DATA_LIST_ERROR_RESPONSE
)
